export default "<canvas #canvasClock></canvas>"